import React from 'react';

import FilterAltIcon from '@mui/icons-material/FilterAlt';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';

interface FilterButtonProps {
  onClick: () => void;
  locked?: boolean;
  ariaLabel?: string;
}

const FilterButton: React.FC<FilterButtonProps> = ({ onClick, locked = false, ariaLabel }) => {
  const theme = useTheme();
  return (
    <Box sx={{ position: 'relative', display: 'inline-block' }}>
      <IconButton
        onClick={onClick}
        size="large"
        sx={{
          backgroundColor: theme.palette.primary.main,
          border: `2px solid ${theme.palette.primary.main}`,
          width: 32,
          height: 32,
          p: 0,
          boxShadow: 0,
          '&:hover': {
            backgroundColor: theme.palette.primary.main,
            boxShadow: 0,
          },
        }}
        aria-label={ariaLabel || 'Open filters'}
      >
        <FilterAltIcon sx={{ fontSize: 20, color: theme.palette.background.default }} />
      </IconButton>
      {locked && (
        <Box
          sx={{
            position: 'absolute',
            bottom: -4,
            right: -4,
            bgcolor: 'transparent',
            borderRadius: '50%',
            p: '2px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: 1,
          }}
        >
          <LockOutlinedIcon sx={{ fontSize: 10, color: theme.palette.text.primary }} />
        </Box>
      )}
    </Box>
  );
};

export default FilterButton;
